import React from 'react'
import KioskMap from './KioskOrderMap'
import FetchData from '../../shared/fetchData'
import Select from '../../components/UI/Select/Select'
import Button from '../../components/UI/Button/Button'
import DatePicker from '../../components/UI/DatePicker/DatePicker'
import TimePicker from '../../components/UI/TimePicker/TimePicker'
import { Toast } from 'reactstrap'
import { Collapse } from '@material-ui/core'

const KioskOrderDetails = (props) => {

    const [latitude, setLatitude] = React.useState(35.7575)
    const [longitude, setLongitude] = React.useState(51.4099)
    const [zoom, setZoom] = React.useState(12)
    const [kioskDetails, setKioskOrderDetails] = React.useState([])
    const [proviances, setProviances] = React.useState([]);
    const [geoNames, setGeoNames] = React.useState([]);
    const [proviance, setProviance] = React.useState('');
    const [geoName, setGeoName] = React.useState('');
    const [kiosk, setKiosk] = React.useState('');
    const [startDate, setStartDate] = React.useState('')
    const [endDate, setEndDate] = React.useState('')
    const [startTime, setStartTime] = React.useState('00:00')
    const [endTime, setEndTime] = React.useState('23:59')
    const [invalidDate, setInvalidDate] = React.useState(false)
    const [invalidTime, setInvalidTime] = React.useState(false)
    const [showLocker, setShowLocker] = React.useState(false)
    const [lockers, setLockers] = React.useState([]);
    const [monitor, setMonitor] = React.useState(false);
    const [showError, setShowError] = React.useState(false);

    React.useEffect(() => {
        var info = {
            "geoName": {
                "type": "PRV"
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/geonames/getGeoNames'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setProviances(result.geoNames);
            })
            .catch(error => console.log(error))
        var info = {
            "finalized": "1",
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/kiosks/getAllKiosksWithDetails'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setKioskOrderDetails(result.kiosks)
            })
            .catch(error => console.log('error', error))
    }, [])

    const changeMapHandler = (event) => {
        let lat = event.target.getCenter().lat
        let lng = event.target.getCenter().lng
        let zoom = event.target.getZoom()
        setLatitude(lat)
        setLongitude(lng)
        setZoom(zoom)
    }
    const changeLocation = (lat, lng) => {
        setLatitude(lat)
        setLongitude(lng)
    }
    const provianceChange = (value) => {
        setProviance(value);
        var info = {
            "geoName": {
                "type": "CTY",
                "parentId": value?.value
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/geonames/getGeoNames'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setGeoNames(result.geoNames);
            })
            .catch(error => console.log(error))
    }
    const geoNameChange = (value) => {
        setLatitude(parseFloat(value.lat))
        setLongitude(parseFloat(value.lon))
        setGeoName(value);
    }
    let provianceList = []
    if (proviances != null && proviances.length != 0) {
        let prvns = [...proviances]
        prvns.map(b => {
            provianceList.push({
                value: b.id,
                label: b.description
            })
        })
    }
    let geoNameList = []
    if (geoNames != null && geoNames.length != 0) {
        let gnms = [...geoNames]
        gnms.map(b => {
            geoNameList.push({
                value: b.id,
                lat: b.lat,
                lon: b.lon,
                label: b.description
            })
        })
    }

    const monitorKioskOrders = (event) => {
        setLockers([]);
        setMonitor(false);
        let valid = true
        if (startTime == null || startTime == '' || startTime == '0:0') {
            valid = false
            setInvalidTime(true)
        }
        if (kiosk == '' || kiosk == undefined) {
            valid = false
            setShowError(true);
            setTimeout(() => {
                setShowError(false)
            }, 5000)
        }
        if (endTime == null || endTime == '' || endTime == '0:0') {
            valid = false
            setInvalidTime(true)
        }
        if (startDate == null || startDate == '') {
            valid = false
            setInvalidDate(true)
        }
        if (endDate == null || endDate == '') {
            valid = false
            setInvalidDate(true)
        }
        if (valid) {
            var info = {
                "kioskId": kiosk?.id,
                "startDate": startDate,
                "startTime": startTime,
                "endDate": endDate,
                "endTime": endTime,
                "pl": 1000,
                "pn": 1,
                "version": "mtpx001"
            }
            var raw = JSON.stringify(info)
            var url = 'management/api/v1/kiosks/monitorKioskOrders'
            FetchData(raw, url).then(response => response.json())
                .then(result => {
                    if (result.status == '0') {
                        setLockers(result.lockers);
                        setMonitor(true);
                    }
                })
                .catch(error => console.log(error))
        }
    }
    const changeStartDate = (unix, formatted) => {
        setStartDate(formatted)
    }
    const changeEndDate = (unix, formatted) => {
        setEndDate(formatted)
    }
    const changeStartTime = (value) => {
        setStartTime(value)
    }

    const changeEndTime = (value) => {
        setEndTime(value)
    }
    const extraInfo = <>
        {showLocker ?
            <div className='row justify-content-center w-100 ml-0 mr-0 mt-3' >
                <div style={{
                    width: '40%',
                    textAlign: 'center',
                    padding: '8px',
                    borderRadius: '9px',
                    backgroundColor: '#111183',
                    color: 'white',
                }} >
                    {kiosk.description}
                </div>
            </div>
            : ''}
        <Collapse in={showError} >
            <div className='row justify-content-center w-100 ml-0 mr-0 mt-3' style={{ color: 'red' }} >
                لطفا لاکر مورد نظر را انتخاب کنید!
            </div>
        </Collapse>
        <div className='row justify-content-center w-100 ml-0 mr-0 mt-3' >
            <DatePicker className={invalidDate && (startDate == null || startDate == '') ? 'invalid-date' : ''} change={changeStartDate} value={startDate} placeHolder="تاریخ شروع جدید" col="6" />
            <TimePicker
                onChange={changeStartTime}
                value={startTime}
                placeHolder="ساعت شروع جدید"
                className={invalidTime && (startTime == null || startTime == '' || startTime == '0:0') ? 'invalid-time' : ''}
                col="6"
            />
            <DatePicker className={invalidDate && (endDate == null || endDate == '') ? 'invalid-date' : ''} change={changeEndDate} value={endDate} placeHolder="تاریخ پایان جدید" col="6" />
            <TimePicker
                onChange={changeEndTime}
                value={endTime}
                placeHolder="ساعت پایان جدید"
                className={invalidTime && (endTime == null || endTime == '' || endTime == '0:0') ? 'invalid-time' : ''}
                col="6"
            />
        </div>
        <div className='row justify-content-center w-100 ml-0 mr-0 mt-3' >
            <Button btnType="Success" clicked={monitorKioskOrders} >مشاهده سفارشات</Button>
        </div>
    </>
    return (
        <div>
            <div className='row justify-content-center w-100 ml-0 mr-0' >
                <Select
                    name="form-field-name"
                    value={proviance}
                    placeholder="استان"
                    options={provianceList}
                    className="map-geo"
                    onChange={provianceChange}
                    col="4 mt-3"
                />
                <Select
                    name="form-field-name"
                    value={geoName}
                    placeholder="شهر"
                    className="map-geo"
                    options={geoNameList}
                    onChange={geoNameChange}
                    col="4 mt-3"
                />
            </div>
            <KioskMap
                lat={latitude}
                lng={longitude}
                kiosks={kioskDetails}
                setKioskId={(value) => { setKiosk(value); setShowLocker(true); }}
                kiosk={kiosk}
                changeLocationOnKiosk={(value) => { setZoom(22); setLatitude(value.lat); setLongitude(value.lon); setKiosk(value); setShowLocker(true); }}
                extraInfo={extraInfo}
                zoom={zoom}
                latLngChangeHandler={changeMapHandler}
                changeLocation={changeLocation}
            />
            {monitor ?
                <>
                    {lockers.map(l => {
                        return (
                            <div className='row w-100 ml-0 mr-0 mt-2' style={{
                                backgroundColor: 'white',
                                border: '1px solid #111183',
                                borderRadius: '9px',
                                padding: '8px',
                            }}>
                                <div className='col-1' style={{ display: 'table', textAlign: 'center' }}>
                                    <div style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>
                                        {l.serial}
                                    </div>
                                </div>
                                <div className='col-11'>
                                    <div className='w-100 ml-0 mr-0' style={{
                                        overflowX: 'auto',
                                        whiteSpace: 'nowrap',
                                        display: 'flex', paddingTop: '9px',
                                        paddingBottom: '9px',
                                    }}>
                                        {l.orders?.map(o => {
                                            return (
                                                <div className='col-6'>
                                                    <div style={{
                                                        boxShadow: '1px 3px 6px gray',
                                                        padding: '8px',
                                                    }}>
                                                        <div className='row w-100 ml-0 mr-0'>
                                                            <div className='col-6'>
                                                                <div className='row w-100 ml-0 mr-0 mt-1'>
                                                                    تاریخ شروع: {o.startDate}
                                                                </div>
                                                                <div className='row w-100 ml-0 mr-0 mt-1'>
                                                                    ساعت شروع: {o.startTime}
                                                                </div>
                                                                <div className='row w-100 ml-0 mr-0 mt-1'>
                                                                    شماره سفارش: {o.orderNumber}
                                                                </div>
                                                                <div className='row w-100 ml-0 mr-0 mt-1'>
                                                                    شناسه سفارش دهنده: {o.courierTrackNumber}
                                                                </div>
                                                            </div>
                                                            <div className='col-6'>
                                                                <div className='row w-100 ml-0 mr-0 mt-1'>
                                                                    تاریخ پایان: {o.endDate}
                                                                </div>
                                                                <div className='row w-100 ml-0 mr-0 mt-1'>
                                                                    ساعت پایان: {o.endTime}
                                                                </div>
                                                                <div className='row w-100 ml-0 mr-0 mt-1'>
                                                                    سفارش دهنده: {o.unit?.unitName}
                                                                </div>
                                                                <div className='row w-100 ml-0 mr-0 mt-1'>
                                                                    بارکد سفارش دهنده: {o.courierBarcode}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </>
                : ''}
        </div>
    )
}

export default KioskOrderDetails